import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
// Nome atual do Supabase é "publishable key"; o de "anon key" fica aceito para projetos antigos.
const chavePublica =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY

/** Sem `.env.local` o app sobe mesmo assim e o login avisa — em vez de tela branca. */
export const supabaseConfigurado = Boolean(url && chavePublica)

// createClient recusa URL vazia; o placeholder só existe para o app renderizar o aviso.
export const supabase = createClient(url || 'http://localhost:54321', chavePublica || 'sem-chave')
